import TreasuryDialog from '../TreasuryDialog';
import React from 'react';
import { CLIENT_FIELDS } from './constants';
import { formatCurrency } from './formatters';

function IssueInvoiceModal({
    visible,
    period,
    clientForm,
    issuerProfile,
    issuing,
    issueError,
    onClose,
    onSubmit,
    onFieldChange,
}) {
    if (!visible || !period) {
        return null;
    }

    return (
        <TreasuryDialog label="Emetre factura" className="aleta-billing-modal" onClose={onClose} closeDisabled={issuing}>
            <div className="aleta-billing-modal-header">
                <div>
                    <h3>Emetre factura {period.label}</h3>
                    <p>Les dades que modifiquis aquí quedaran congelades només a aquesta factura.</p>
                </div>
                <button className="aleta-billing-close-button" aria-label="Tancar" onClick={onClose} disabled={issuing}>
                    ×
                </button>
            </div>

            <div className="treasury-dialog-body">
                {issueError ? (
                    <div className="aleta-billing-alert error">
                        {issueError}
                    </div>
                ) : null}

                <div className="aleta-billing-modal-grid">
                    <div className="aleta-billing-form-section">
                        <h4>Dades del client</h4>
                        <div className="aleta-billing-form-grid">
                            {CLIENT_FIELDS.map(field => (
                                <label key={field.key} className={field.wide ? 'wide' : ''}>
                                    <span>
                                        {field.label}
                                        {field.required ? ' *' : ''}
                                    </span>
                                    <input
                                        type="text"
                                        value={clientForm[field.key] || ''}
                                        onChange={(event) => onFieldChange(field.key, event.target.value)}
                                        disabled={issuing}
                                    />
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="aleta-billing-summary-section">
                        <h4>Resum econòmic</h4>
                        <div className="aleta-billing-summary-card">
                            <div className="aleta-billing-summary-row">
                                <span>Concepte</span>
                                <strong>{period.monthsInPeriod} {period.monthsInPeriod === 1 ? 'mes' : 'mesos'} d&apos;Aleta</strong>
                            </div>
                            <div className="aleta-billing-summary-row">
                                <span>Base imposable</span>
                                <strong>{formatCurrency(period.amounts.baseAmount)}</strong>
                            </div>
                            <div className="aleta-billing-summary-row">
                                <span>IVA</span>
                                <strong>{formatCurrency(period.amounts.vatAmount)}</strong>
                            </div>
                            <div className="aleta-billing-summary-row">
                                <span>Retenció</span>
                                <strong>-{formatCurrency(period.amounts.withholdingAmount)}</strong>
                            </div>
                            <div className="aleta-billing-summary-row total">
                                <span>Total</span>
                                <strong>{formatCurrency(period.amounts.totalAmount)}</strong>
                            </div>
                        </div>

                        <div className="aleta-billing-issuer-card">
                            <h5>Emissor</h5>
                            <p>{issuerProfile?.name || 'Aleta'}</p>
                            <p>{issuerProfile?.nif || '-'}</p>
                            <p>{issuerProfile?.email || '-'}</p>
                        </div>
                    </div>
                </div>

            </div>
            <div className="aleta-billing-modal-actions treasury-dialog-footer">
                <button className="aleta-billing-secondary-button" onClick={onClose} disabled={issuing}>
                    Cancel·lar
                </button>
                <button className="aleta-billing-primary-button" onClick={onSubmit} disabled={issuing}>
                    {issuing ? 'Emetent...' : 'Emetre i guardar PDF'}
                </button>
            </div>
        </TreasuryDialog>
    );
}

export default IssueInvoiceModal;
